module.exports = __webpack_public_path__ + "img/lang-pt.260c9369.png";